// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__35i0r","header":"MergedInvoice_header__1pp9h"};